module.exports = __webpack_public_path__ + "media/backgrounds/diamond-array-purple-5b6a886b.png";